{
  "names": {
    "Fajr": "Fajr",
    "Dhuhr": "Dhuhr",
    "Asr": "Asr",
    "Maghrib": "Maghrib",
    "Isha": "Isha"
  },
  "card": {
    "label": "Следующая молитва",
    "labelTomorrow": "Завтра · {{prayer}}",
    "inHoursMinutes": "через {{hours}} ч {{minutes}} мин",
    "inMinutes": "через {{minutes}} мин",
    "open_aria": "Открыть время молитв",
    "pro": "Rhemn Pro",
    "unlock_aria": "Откройте время молитв с Rhemn Pro",
    "unavailable": "Время намаза сейчас недоступно."
  },
  "sheet": {
    "bellOn_aria": "Выключить напоминание о {{prayer}}",
    "bellOff_aria": "Включить напоминание о {{prayer}}",
    "explainer": "Получайте тихое напоминание перед каждой молитвой. Напоминания — беззвучные уведомления, по умолчанию без звука.",
    "enableReminders": "Включить напоминания",
    "enableInSettings": "Включите уведомления Rhemn в Настройках, чтобы получать напоминания о молитве.",
    "openSettings": "Открыть настройки"
  },
  "notifications": {
    "body": "Время молитвы."
  },
  "focus": {
    "label": "Молитва {{prayer}}",
    "close_aria": "Закрыть экран молитвы",
    "hint": "Нажмите Esc или ×, чтобы вернуться",
    "phrases": {
      "accepted": "Да примет Аллах вашу молитву",
      "acceptedAr": "تقبّل الله صلاتك"
    }
  },
  "ambient": {
    "default": "Начните с намерения. Продолжайте с баракят.",
    "prayerApproaches": "Приближается следующая молитва. Оставайтесь верны своему намерению.",
    "morningPursue": "Благословенное утро для стремления: {{focus}}",
    "dayCloses": "На исходе дня поразмышляйте о: {{focus}}",
    "fulfilled": "Сегодня вы исполнили своё намерение. Альхамдулиллях.",
    "workingTowards": "Сегодня вы работаете над: {{focus}}",
    "prayerNear": "Следующая молитва близко. Сделайте вдох."
  },
  "widget": {
    "countdown": "через {{time}}",
    "openToUpdate": "Откройте Rhemn, чтобы обновить",
    "openForVerse": "Откройте Rhemn, чтобы увидеть аят дня"
  }
}
